// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".em-page-gradient-positioner{position:absolute;top:108px;left:0;width:100%;z-index:-1}", ""]);
// Exports
module.exports = exports;
